import { Component, Input } from '@angular/core';

/**
 * Shared page header: small muted breadcrumb line + large bold title, matching the design
 * mockup's d1BreadcrumbStyle/d1ScreenTitleStyle pattern. `actions` content projection slot is
 * for page-specific action buttons - this component never assumes what those are.
 */
@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
    @Input() title: string;
    @Input() breadcrumb?: string[];
    @Input() description?: string;
}
